import axios from 'axios';

const state = {
    adminTickets: [],
    adminTotalTickets: 0,
    adminCurrentTicket: null,
    adminCurrentMessages: [],
    adminCurrentUser: null,
    adminCurrentUserPackage: '',
    adminCurrentUserTotalTickets: 0,
    adminStats: { open: 0, in_progress: 0, waiting_user: 0, closed: 0, closed_today: 0, total_unread: 0 },
};

const actions = {
    admin_support_ticket_list({ commit }, params) {
        return axios.get('admin/support-tickets', { params: params || {} }).then(r => {
            commit('SET_ADMIN_SUPPORT_TICKETS', { list: r.data.data.tickets || [], total: r.data.data.total || 0 });
            return r;
        });
    },
    admin_support_ticket_detail({ commit }, id) {
        return axios.get('admin/support-tickets/' + id).then(r => {
            commit('SET_ADMIN_SUPPORT_CURRENT', r.data.data);
            return r;
        });
    },
    admin_support_ticket_reply(_, { id, formData }) {
        return axios.post('admin/support-tickets/' + id + '/reply', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
    admin_support_ticket_status(_, { id, status }) {
        return axios.put('admin/support-tickets/' + id + '/status', { status });
    },
    admin_support_invoice_options(_, id) {
        return axios.get('admin/support-tickets/' + id + '/invoice-options');
    },
    admin_support_send_invoice(_, { id, package_id, message, mark_paid }) {
        return axios.post('admin/support-tickets/' + id + '/send-invoice', { package_id, message, mark_paid: !!mark_paid });
    },
    admin_support_ticket_extend_package(_, { id, days }) {
        return axios.post('admin/support-tickets/' + id + '/extend-package', { days });
    },
    admin_support_ticket_change_package(_, { id, package_id, extend_days }) {
        return axios.post('admin/support-tickets/' + id + '/change-package', { package_id, extend_days });
    },
    admin_support_ticket_reset_password(_, { id, new_password }) {
        return axios.post('admin/support-tickets/' + id + '/reset-password', { new_password });
    },
    admin_support_ticket_adjust_balance(_, { id, type, amount, note }) {
        return axios.post('admin/support-tickets/' + id + '/adjust-balance', { type, amount, note });
    },
    admin_support_ticket_toggle_block(_, { id, block, reason }) {
        return axios.post('admin/support-tickets/' + id + '/toggle-block', { block, reason });
    },
    admin_support_invoice_history(_, { id, status, limit }) {
        const params = {};
        if (status) params.status = status;
        if (limit) params.limit = limit;
        return axios.get('admin/support-tickets/' + id + '/invoice-history', { params });
    },
    admin_support_send_paid_invoice(_, { id, transaction_id, message }) {
        return axios.post('admin/support-tickets/' + id + '/send-paid-invoice', { transaction_id, message });
    },
    admin_support_ticket_stats({ commit }) {
        return axios.get('admin/support-tickets/stats').then(r => {
            commit('SET_ADMIN_SUPPORT_STATS', r.data.data.stats || {});
            return r;
        });
    },
    admin_support_ticket_ai_draft_start(_, id) {
        return axios.post('admin/support-tickets/' + id + '/ai-draft');
    },
    admin_support_ticket_ai_draft_status(_, id) {
        return axios.get('admin/support-tickets/' + id + '/ai-draft/status');
    },
    admin_support_ticket_ai_draft_send(_, { id, draftId, message }) {
        return axios.post('admin/support-tickets/' + id + '/ai-draft/' + draftId + '/send', { message: message || '' });
    },
    admin_support_ticket_ai_draft_discard(_, id) {
        return axios.post('admin/support-tickets/' + id + '/ai-draft/discard');
    },
};

const mutations = {
    SET_ADMIN_SUPPORT_TICKETS(state, { list, total }) {
        state.adminTickets = list;
        state.adminTotalTickets = total;
    },
    SET_ADMIN_SUPPORT_CURRENT(state, data) {
        state.adminCurrentTicket = data.ticket;
        state.adminCurrentMessages = data.messages || [];
        state.adminCurrentUser = data.user;
        state.adminCurrentUserPackage = data.user_package || '';
        state.adminCurrentUserTotalTickets = data.user_total_tickets || 0;
    },
    SET_ADMIN_SUPPORT_STATS(state, stats) { state.adminStats = stats; },
    APPEND_ADMIN_SUPPORT_MESSAGE(state, msg) { state.adminCurrentMessages.push(msg); },
};

export default { state, actions, mutations };
